import { type SharedData } from '@/types';
import { Head, usePage } from '@inertiajs/react';

// Components
import {
  Header,
  HeroSection,
  TribeSection,
  FeatureIcons,
  WaitingListForm,
  Footer,
  NetworkBackground
} from '@/components/landing';

// Add custom animation styles
const animationStyles = `
@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
}

@keyframes blob {
  0% { transform: scale(1) translate(0px, 0px); }
  33% { transform: scale(1.1) translate(20px, -10px); }
  66% { transform: scale(0.9) translate(-20px, 10px); }
  100% { transform: scale(1) translate(0px, 0px); }
}

.animate-float {
  animation: float 6s ease-in-out infinite;
}

.animate-blob {
  animation: blob 8s infinite;
}

.animation-delay-2000 {
  animation-delay: 2s;
}

.animation-delay-4000 {
  animation-delay: 4s;
}
`;

interface PageProps extends SharedData {
    flash?: {
        success?: string;
        error?: string;
    };
    showWaitingList?: boolean;
}

export default function Welcome() {
    const { auth, flash, showWaitingList } = usePage<PageProps>().props;

    return (
        <>
            <Head title="Protribe - Your Professional Networking Platform">
                <style>{animationStyles}</style>
            </Head>
            
            <div className="min-h-screen relative font-heading" style={{ background: '#EFF6FF' }}>
                {/* Network Background */}
                <NetworkBackground className="z-0" />

                {/* Content */}
                <div className="relative z-10">
                    {/* Header */}
                    <Header auth={auth} showWaitingList={showWaitingList} />
                    
                    {/* Hero Section */}
                    <HeroSection
                        title={<>Real connections,<br/>Relevant conversations</>}
                        subtitle="Join a community of product, design, and engineering professionals focused on building meaningful connections and shared growth."
                    />
                    
                    {/* Tribe Section */}
                    <TribeSection
                        title="Why Protribe"
                        description="A professional network designed for meaningful connections. Protribe helps you meet the right people, have better conversations, and stay connected through communities that actually matter to your work."
                    />
                    
                    {/* Feature Icons */}
                    <FeatureIcons />
                    
                    {/* Waiting List Form */}
                    {showWaitingList && <WaitingListForm successMessage={flash?.success} />}
                    
                    {/* Footer */}
                    <Footer />
                </div>
            </div>
        </>
    );
}